if (!customElements.get('cinoton-product-tabs')) {
  class CinotonProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-product-tab]')];
      this.panels = [...this.querySelectorAll('[data-product-panel]')];
      this.moreLinks = [...this.querySelectorAll('[data-product-more]')];
      const signal = this.events.signal;

      // Delegation survives Shopify editor updates to individual tab blocks.
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.contains(tab)) return;
        event.preventDefault();
        this.activate(tab.dataset.productTab);
      }, { capture: true, signal });

      this.addEventListener('mouseover', (event) => {
        if (this.dataset.switchMode !== 'hover' || !window.matchMedia('(hover: hover)').matches) return;
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.contains(tab) || tab.contains(event.relatedTarget)) return;
        this.activate(tab.dataset.productTab);
      }, { capture: true, signal });

      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.tabs[next].focus();
        this.activate(this.tabs[next].dataset.productTab);
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-product-panel]');
        if (panel && this.contains(panel)) this.activate(panel.dataset.productPanel);
      }, { signal });

      const selected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      if (selected) this.activate(selected.dataset.productTab);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }

    activate(id) {
      if (!this.tabs?.some((tab) => tab.dataset.productTab === id)) return;
      this.tabs.forEach((tab) => {
        const active = tab.dataset.productTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.productPanel !== id; });
      this.moreLinks.forEach((link) => { link.hidden = link.dataset.productMore !== id; });
    }
  }
  customElements.define('cinoton-product-tabs', CinotonProductTabs);
}
